import { useState } from "react";

export default function Tabs({ tabs }) {
    const [activeTab, setActiveTab] = useState(tabs[0]?.key || "");

    return (
        <div>
            {/* Nav */}
            <ul className="flex border-b">
                {tabs.map((tab) => (
                    <li key={tab.key}>
                        <button
                            onClick={() => !tab.disabled && setActiveTab(tab.key)}
                            disabled={tab.disabled}
                            className={`px-4 py-2 -mb-px border-b-2 font-medium text-sm 
                ${tab.disabled
                                    ? "text-gray-400 cursor-not-allowed border-transparent"
                                    : activeTab === tab.key
                                        ? "border-[#FA6300] text-[#FA6300]"
                                        : "border-transparent text-gray-500 hover:text-gray-700"
                                }`}
                        >
                            {tab.label}
                        </button>
                    </li>
                ))}
            </ul>

            {/* Conteúdo */}
            <div className="p-4">
                {tabs.find((tab) => tab.key === activeTab)?.component}
            </div>
        </div>
    );
}
